export default {
    name: 'page-not-found',
}
